/*
 * @Author: wenxiaopeng
 * @LastEditors: Please set LastEditors
 * @Description:  */

import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            // 首页,基础配置
            name: 'Home',
            path: '/Home/UserManagement',
            type: 'UserManagement',
            label: 'UserManagement',
            component: () => import('@/views/Home.vue'),
            redirect: '/Home/UserManagement',
            children: [
                {
                    path: '/Home/UserManagement',
                    name: '用户管理',
                    component: () =>
                        import('@/views/UserManagement.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                },
                {
                    path: '/Home/RoleManagement',
                    name: '角色管理',
                    component: () =>
                        import('@/views/RoleManagement.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                },
                {
                    path: '/Home/MenuManagement',
                    name: '菜单管理',
                    component: () =>
                        import('@/views/MenuManagement.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                },
                {
                    path: '/Home/PageElements',
                    name: '页面元素',
                    component: () =>
                        import('@/views/PageElements.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                },
                {
                    path: '/Home/OperationalManagement',
                    name: '操作管理',
                    component: () =>
                        import('@/views/OperationalManagement.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                }
            ]
        },
        {
            // 首页
            name: 'Home',
            path: '/Home',
            type: 'HomePage',
            label: 'HomePage',
            component: () => import('@/views/Home.vue'),
            children: [
                {
                    path: '/Home/CsCodeManagement',
                    name: '代码维护',
                    component: () =>
                        import('@/views/CsCodeManagement.vue'),
                    leaf: true,
                    menuShow: true,
                    iconCls: 'el-icon-s-data'
                }
            ]
        },
        {
            // 登录
            name: 'Login',
            path: '/login',
            component: () =>
                import('@/components/Login.vue')
        },
        {
            // 登录
            name: 'Login',
            path: '/',
            component: () =>
                import('@/components/Login.vue')
        },
        {
            // 知识中心
            name: '知识中心',
            path: '/KnowledgeCenter',
            component: () =>
                import('@/views/KnowledgeCenter.vue')
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js